import { graphql } from 'react-relay/hooks'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportTemplateUpdateMutation($input: UpdateReportTemplateByIdInput!) {
    updateReportTemplateById(input: $input) {
      reportTemplate {
        rowId
        id
        name
        config
        organizationId
      }
    }
  }
`

export default function useTemplateUpdate() {
  return useMutation(mutation, 'updateReportTemplateById')
}
